import moment from 'moment'

import {GetCharacterMeta} from '@/graphql/queries/Character.graphql'

export default {
  data(){
    return {
      updateInterval  : 180
    };
  },

  apollo : {
    characterMetaList : {
      query : GetCharacterMeta
    }
  },

  computed : {
    applicationDataFetchDate(){
      return this.$store.state.applicationDataFetchDate;
    },
  },

  methods : {
    playgrounds(){
      const checkDate = moment(new Date());
      checkDate.subtract(5, 'minutes');
      
      console.log(checkDate.format());

      const diffSecs = moment(new Date()).diff(checkDate, 'seconds');

      console.log(diffSecs);

      if(diffSecs >= this.updateInterval){
        console.log('refetch');
      }else{
        console.log('no refetch');
      }
    },

    shoudFetchApplicationData(){
      if(this.applicationDataFetchDate === null){
        return true;
      }

      const diffSecs = moment(new Date()).diff(this.applicationDataFetchDate, 'seconds');
      if(diffSecs >= this.updateInterval){
        return true;
      }

      return false;
    },

    fetchApplicationData(){
      if(!this.shoudFetchApplicationData()) return;

      this.$apollo.queries.characterMetaList.refetch();
    }
  }
}